/*
 * Decorative arc pattern (Figma Page Title 119:11053, Dashboard Footer 119:15188).
 * Box: absolute, top 0, right -1px, width 1042, height 256 (title) / 157 (footer), clipped.
 * Fill: absolute left -106.5px top -52px, 1255.265 × 703.5, opacity .4, masked by
 *   (a) a left→right alpha fade: 974 × 256|159 at 173.5px 52|50px, and
 *   (b) the arc shapes: 1041.725 × 1054.665 at 136.5px -42px.
 * Both masks apply (intersect) and don't tile, as in Figma.
 * Not in Figma (Kenno, 2026-10-03): the fill is moving colour (.pattern-oil in index.css) instead of
 * Figma's image (pattern.png), like the strip on distribuai.com but more subtle.
 */
import fadeFooter from '@/assets/figma/brand/pattern-mask-footer.svg'
import fadeHeader from '@/assets/figma/brand/pattern-mask-header.svg'
import arcShapes from '@/assets/figma/brand/pattern-mask-shape.svg'

const VARIANT = {
    header: { boxHeight: 256, fade: fadeHeader, fadeHeight: 256, fadeY: 52 },
    footer: { boxHeight: 157, fade: fadeFooter, fadeHeight: 159, fadeY: 50 },
} as const

export function Pattern({ variant }: { variant: keyof typeof VARIANT }) {
    const v = VARIANT[variant]
    const mask = {
        maskImage: `url("${v.fade}"), url("${arcShapes}")`,
        maskPosition: `173.5px ${v.fadeY}px, 136.5px -42px`,
        maskSize: `974px ${v.fadeHeight}px, 1041.725px 1054.665px`,
        maskRepeat: 'no-repeat, no-repeat',
        maskComposite: 'intersect',
        WebkitMaskImage: `url("${v.fade}"), url("${arcShapes}")`,
        WebkitMaskPosition: `173.5px ${v.fadeY}px, 136.5px -42px`,
        WebkitMaskSize: `974px ${v.fadeHeight}px, 1041.725px 1054.665px`,
        WebkitMaskRepeat: 'no-repeat, no-repeat',
        WebkitMaskComposite: 'source-in',
    } as const
    return (
        <div aria-hidden className="pointer-events-none absolute top-0 right-[-1px] w-[1042px] overflow-clip" style={{ height: v.boxHeight }}>
            <div className="pattern-oil absolute top-[-52px] left-[-106.5px] h-[703.5px] w-[1255.265px] overflow-clip opacity-40" style={mask}>
                <span className="pattern-oil-a">
                    <span />
                </span>
                <span className="pattern-oil-b">
                    <span />
                </span>
            </div>
        </div>
    )
}
